import { BeachSection } from "../sections/beach";
import { CitySection } from "../sections/city";
import { EssentialsSection } from "../sections/essentials";
import { NatureSection } from "../sections/nature";
import { OtherSection } from "../sections/other";
import { PricesSection } from "../sections/prices";
import { WeatherSection } from "../sections/weather";

export const categoriesItems = [
    {
        title: "Travel essentials",
        section: "essentials",
        component: EssentialsSection
    },
    { title: "Weather", section: "weather", component: WeatherSection },
    { title: "Beach", section: "beach", component: BeachSection },
    { title: "Nature", section: "nature", component: NatureSection },
    { title: "City", section: "city", component: CitySection },
    { title: "Prices", section: "prices", component: PricesSection },
    { title: "Other", section: "other", component: OtherSection }
];
